import { useModals } from '@frontend/modal';
import React from 'react';
import { LuArrowLeft } from 'react-icons/lu';

interface DetailModalHeaderProps {
    title: React.ReactNode;
    handleClose?: () => void;
}

export const DetailModalHeader = (props: DetailModalHeaderProps) => {
    const { closeTopModal } = useModals();
    return (
        <div className='inline-flex w-full items-center justify-between'>
            <div className='flex items-center justify-start gap-3'>
                <div
                    onClick={props.handleClose ?? closeTopModal}
                    className='bg-background-surface border-border-default hover:bg-brand-light relative flex size-11 cursor-pointer items-center justify-center self-center rounded-md border'>
                    <LuArrowLeft className='text-brand-muted size-6' />
                </div>
                <div className='text-foreground-default justify-start text-xl font-semibold md:text-3xl'>{props.title}</div>
            </div>
        </div>
    );
};
